export const parse_saswpSchema = (content, hostname, current_hostname) => {
	try {

		if (!content) return null;
		const schema_json = content.map((item, i) => {
			let obj = item;

			if (item.author) {

				let url = obj.author.url.replace(hostname, current_hostname);
				let sameAs = obj.author.sameAS;

				if (sameAs && sameAs.length > 0) {
					sameAs[0] = sameAs[0].replace(hostname, current_hostname);
				}

				obj = { ...obj, author: { ...obj.author, url, sameAs } };
			}

			if (item["@id"]) {
				let id = item["@id"];

				id = id.replace(hostname, current_hostname);

				obj = { ...obj, "@id": id };
			}

			if (item.url) {
				let url = obj.url.replace(hostname, current_hostname);

				obj = { ...obj, url };
			}
			if (item.isPartOf && item.isPartOf["@id"]) {
				obj.isPartOf["@id"] = obj.isPartOf["@id"].replace(
					hostname,
					current_hostname
				);
			}

			if (Array.isArray(item.image) && item.image && item.image.length > 0) {
				obj.image = obj.image.map((x) => {
					if (x["@id"]) {
						let id = x["@id"];
						id = id.replace(hostname, current_hostname);

						return { ...x, "@id": id };
					}

					return { ...x };
				});
			}
			if (!Array.isArray(item.image) && item.image && item.image["@id"]) {
				obj.image["@id"] = item.image["@id"].replace(hostname, current_hostname);
			}

			if (item.logo && item.logo["@id"]) {
				obj.logo["@id"] = item.logo["@id"].replace(hostname, current_hostname);
			}

			if (item.sameAs && item.sameAs.length > 0) {
				obj.sameAs = obj.sameAs.map((x) => {
					const parsed = x.replace(hostname, current_hostname);

					return parsed;
				});
			}

			if (item["@graph"]) {
				obj["@graph"] = obj["@graph"].map((item) => {
					let updated = item;

					if (item["@id"]) {
						updated["@id"] = item["@id"].replace(hostname, current_hostname);
					}

					if (item["url"]) {
						updated["url"] = item["url"].replace(hostname, current_hostname);
					}

					return updated;
				});
			}
			if (item["breadcrumb"] && item["breadcrumb"]["@id"]) {
				obj["breadcrumb"]["@id"] = item["breadcrumb"]["@id"].replace(
					hostname,
					current_hostname
				);
			}

			if (item.itemListElement) {
				obj.itemListElement = obj.itemListElement.map((element) => {
					let updated = element;

					if (element.item && element.item["@id"]) {
						updated.item["@id"] = element.item["@id"].replace(
							hostname,
							current_hostname
						);
					}
					if (element.item && !element.item["@id"]) {
						updated.item = element.item.replace(hostname, current_hostname);
					}

					return updated;
				});
			}
			if (item.potentialAction && item.potentialAction.length > 0) {
				obj.potentialAction = obj.potentialAction.map((element) => {
					let updated = element;

					if (element.target && element.target.urlTemplate) {
						updated.target.urlTemplate = element.target.urlTemplate.replace(
							hostname,
							current_hostname
						);
					}

					return updated;
				});
			}

			if (item.mainEntityOfPage) {
				let mainEntityOfPage = obj.mainEntityOfPage.replace(
					hostname,
					current_hostname
				);

				obj = { ...obj, mainEntityOfPage };
			}

			if (item.publisher) {
				if (item.publisher.url) {
					let url = obj.publisher.url.replace(
						hostname.slice(0, -1),
						current_hostname.slice(0, -1)
					);
					let publisher = { ...item.publisher, url };
					obj = { ...obj, publisher };
				}
				if (item.publisher["@id"]) {
					obj.publisher["@id"] = obj.publisher["@id"].replace(
						hostname.slice(0, -1),
						current_hostname.slice(0, -1)
					);
				}
			}

			return { ...obj };
		});

		return schema_json;
	} catch (e) {
		console.log("ERROR WHILE PARSING", e);
		throw createError({
			statusCode: 500,
			fatal: true
		});
	}
};
